import axios from "axios";
import { baseUrlOtodis, xApiKeyOtodis, baseUrlDdms } from "../../config/api/apiConfig";

class DdmsInvoiceApiService {
  private axios = axios.create({
    baseURL: baseUrlOtodis,
    timeout: 5000000,
  });

  private axios2 = axios.create({
    baseURL: baseUrlDdms,
    timeout: 5000000,
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    this.axios2.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getInvoices(params?: any) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.startDate && {
        start_date: params.startDate,
      }),
      ...(params?.endDate && {
        end_date: params.endDate,
      }),
    };
    try {
      return await this.axios2.get<any>("/ddms/document", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response?.data?.message ?? "Error");
    }
  }

  public async saveInvoices(inputData?: any) {
    try {
      return await this.axios.post<any>("/ddms/document", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e.response.data.message);
    }
  }

  public async getBast(params?: any) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.startDate && {
        start_date: params.startDate,
      }),
      ...(params?.endDate && {
        end_date: params.endDate,
      }),
    };
    try {
      return await this.axios2.get<any>("/ddms/bast", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response?.data?.message ?? "Error");
    }
  }

  public async saveBast(inputData?: any) {
    try {
      return await this.axios.post<any>("/ddms/bast", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e.response.data.message);
    }
  }
}

export const ddmsInvoiceApiService = new DdmsInvoiceApiService();
